import {Component, Directive, HostListener, inject, input, model} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule} from '@angular/material/dialog';
import {
    VulcanDateTimePickerComponent,
    VulcanDateTimePickerConfig,
    VulcanDateTimePickerForm,
    VulcanIconComponent,
} from '@eagle-i/vulcan-component-library';

@Component({
    selector: 'eaglei-date-time-picker-modal',
    imports: [VulcanDateTimePickerComponent, VulcanIconComponent, MatDialogModule, MatButtonModule],
    templateUrl: './date-time-picker-modal.component.html',
    styleUrls: ['../shared-modals.scss', './date-time-picker-modal.component.scss'],
})
export class DateTimePickerModalComponent {
    public data = inject<{
        config: VulcanDateTimePickerConfig;
        form: FormGroup<VulcanDateTimePickerForm>;
        title: string;
    }>(MAT_DIALOG_DATA);
}
